// extracted by mini-css-extract-plugin
export default {"projectBlock":"ProjectBlock_projectBlock__hTd+s","title":"ProjectBlock_title__qh2yA","whiteLine":"ProjectBlock_whiteLine__1R5rT","cards":"ProjectBlock_cards__Y2js9"};